import React from 'react';
import Button from 'components/Button';
import { Props as FormProps } from 'src/lib/components/Form';
import {
  ValidationErrorComponent,
  Label,
  FieldWrap,
  FieldInnerWrap,
  SubmissionMessage,
} from '.';

const defaultFormStyles: Partial<FormProps> = {
  validationErrorComponent: (theProps) => <ValidationErrorComponent {...theProps} />,
  labelComponent: Label,
  fieldWrapComponent: FieldWrap,
  fieldInnerWrapComponent: FieldInnerWrap,
  submissionMessageComponent: SubmissionMessage,
  submitComponent: (buttonProps) => (
    <Button
      onClick={() => {}}
      {...buttonProps}
      type="primary"
      typeAttribute="submit"
    >
      Submit
    </Button>
  ),
};

export default defaultFormStyles;
